import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RomaneioEdicaoPage } from '@/features/romaneio/page/edicao/RomaneioEdicaoPage';
import { StringToIdpkSchema } from '@/std/schema';

const RouteRomaneioParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteRomaneioParams = z.infer<typeof RouteRomaneioParamsSchema>;

export const Route = createFileRoute('/a/romaneio/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteRomaneioParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <RomaneioEdicaoPage {...params} />;
}
